import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-customer-confirm-dialog',
  templateUrl: './customer-confirm-dialog.component.html',
  styleUrls: ['./customer-confirm-dialog.component.scss']
})
export class CustomerConfirmDialogComponent {

  customerConfirmMailForm: FormGroup;

  isRequiredCode = false;

  @Input() data: { message: string, title: string }

  constructor(
    public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.customerConfirmMailForm = this.fb.group({
      code: [null],
    });
  }

  closeModal(result) {
    this.activeModal.close(result);
  }

  changeCode() {
    this.isRequiredCode = !this.isRequiredCode;

    const codeControl = this.customerConfirmMailForm.get('code');

    if (this.isRequiredCode) {
      codeControl.setValidators([Validators.required]);
    } else {
      codeControl.clearValidators();
    }

    codeControl.updateValueAndValidity(); // <-- Çok önemli!
  }

}
